export const governingLawAndSeverability = () => {
  return [
    { text: '     18. GOVERNING LAW AND SEVERABILITY', bold: true, style: 'p', },

    { text: "      This TICA shall be governed by the laws of the State of California. If any provision of this TICA or portion thereof is held to be unenforceable, said provision or portion" +
        " thereof shall not prejudice the enforceability of any other provision or portion", style: 'p' },
  ]
}